import { permissions } from '../constants/permissions';
/**
 * Convert API Roles into permissions
 * roleId:
 *  1: Admin
 *  2: Write
 *  3: Read
 *  4: No-Access
 */

export var mapOrganisationAccessToPermission = function mapOrganisationAccessToPermission(roleId) {
  var isInternalUser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isAccountManager = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false; // Internal Admin

  if (isInternalUser) {
    return permissions.INTERNAL_ADMIN;
  } // Account Manager Admin


  if (isAccountManager) {
    return permissions.ACCOUNT_MANAGER_ADMIN;
  } // Organisation Admin


  if (roleId === 1) {
    return permissions.ORGANISATION_ADMIN;
  } // Organisation Read


  if (roleId === 2) {
    return permissions.WRITE;
  } // Organisation Read


  if (roleId === 3) {
    return permissions.READ;
  }

  return permissions.NO_ACCESS;
};
export var restrictUserPermissions = function restrictUserPermissions(allowedPermissions, userPermission) {
  return allowedPermissions.includes(userPermission) || false;
};
export var getPermissionInProduct = function getPermissionInProduct(prodId, auth) {
  if (!auth) {
    return null;
  }

  return auth[prodId] ? auth[prodId].permission : permissions.NO_ACCESS;
};